import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'escapeAwareCharCount',
  standalone: true
})
export class EscapeAwareCharCountPipe implements PipeTransform {

  transform(value: string): number {
    if (!value) return 0;

    // Speciális karakterek escape-elése után várható hossz
    let escapedLength = 0;
    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      if (char === '\\' || char === '\n' || char === '\r' || char === '\t' || char === '"') {
        escapedLength += 2; // escape karakter + eredeti karakter
      } else {
        escapedLength += 1;
      }
    }

    return escapedLength;

  }

}
